import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningAmber from '@mui/icons-material/WarningAmber';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@/ui';
import { deleteEntity, resetModal } from '../../actions';

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggleModal = async () => {
    if (this.state.isOpen) {
      this.props.resetModal();
    }
    await this.setState({ isOpen: !this.state.isOpen });
  };

  renderDeleteButton() {
    // A quiet icon button: a solid red block per table row out-shouted the data it sat beside.
    // The destructive emphasis belongs to the confirm button inside the modal. `outlined` draws
    // a border for the detail headers, where the icon sits in a row of real buttons and a bare
    // glyph read as an afterthought.
    return (
      <IconButton
        size='small'
        color='error'
        aria-label='Delete'
        title='Delete'
        onClick={this.toggleModal}
        sx={this.props.outlined ? { border: 1, borderColor: 'error.main', borderRadius: 1 } : undefined}
      >
        <DeleteIcon fontSize='small' />
      </IconButton>
    );
  }

  deleteEntity = async () => {
    await this.props.deleteEntity(this.props.id, this.props.entity);

    if (this.props.saveError) return;
    this.toggleModal();
    if (Object.keys(this.props.match.params).length > 0) {
      return this.props.navigate(`/campaigns/${this.props.entity}/`);
    }
    return window.location.reload();
  };

  render() {
    return (
      <div>
        {this.renderDeleteButton()}
        <Modal isOpen={this.state.isOpen} toggle={this.toggleModal} tone='danger'>
          <ModalHeader toggle={this.toggleModal}>Delete</ModalHeader>
          <ModalBody>
            <Stack direction='row' spacing={2} sx={{ alignItems: 'flex-start' }}>
              <WarningAmber sx={{ fontSize: '3rem', color: 'error.main', flex: '0 0 auto' }} />
              {this.props.saveError ? (
                <div>
                  <Typography variant='h6'>Error:</Typography>
                  <Typography>{this.props.error.message}</Typography>
                </div>
              ) : (
                <div>
                  <Typography variant='h6'>{this.props.content && this.props.content.name}</Typography>
                  <Typography>
                    Are you sure you want to <strong>delete</strong> this
                    {this.props.modalType}? This action is <strong>irreversible.</strong>
                  </Typography>
                </div>
              )}
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button color='danger' onClick={this.deleteEntity}>
              Delete
            </Button>{' '}
            <Button color='secondary' onClick={this.toggleModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { saveError, error } = state.components;
  return { saveError, error };
}

export default withRouter(connect(mapStateToProps, { deleteEntity, resetModal })(DeleteModal));
